//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KirbyLink from './kirbylink.vue'
export default {
    name: "customerservice",
    props:{
      content: Object
    },
    components:{
      KirbyLink
    }
}
